/**
 * MobileTabBar — Bottom tab navigation for mobile.
 * Extracted from __root.tsx.
 */

import { Link } from "@tanstack/react-router";
import { Home, Search, Package, ShoppingBag } from "lucide-react";
import { useCart } from "@/features/cart/store/cart-store";

export function MobileTabBar() {
  const { setOpen, count } = useCart();

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-4 border-t border-border/70 bg-background/95 backdrop-blur md:hidden pb-[env(safe-area-inset-bottom)]"
      aria-label="Mobile tab navigation"
    >
      <Link
        to="/"
        aria-label="Home"
        className="grid min-h-14 place-items-center transition-colors hover:text-primary focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-emerald-800"
      >
        <Home className="h-5 w-5" strokeWidth={1.25} />
      </Link>
      <Link
        to="/shop"
        aria-label="Shop"
        className="grid min-h-14 place-items-center transition-colors hover:text-primary focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-emerald-800"
      >
        <Search className="h-5 w-5" strokeWidth={1.25} />
      </Link>
      <Link
        to="/orders"
        aria-label="Orders & Tracking"
        className="grid min-h-14 place-items-center transition-colors hover:text-primary focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-emerald-800"
      >
        <Package className="h-5 w-5" strokeWidth={1.25} />
      </Link>
      <button
        onClick={() => setOpen(true)}
        aria-label={`Shopping bag, ${count} items`}
        className="relative grid min-h-14 place-items-center transition-colors hover:text-primary focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-emerald-800"
      >
        <ShoppingBag className="h-5 w-5" strokeWidth={1.25} />
        {count > 0 && (
          <span
            aria-hidden="true"
            className="absolute right-6 top-3 h-1.5 w-1.5 rounded-full bg-accent"
          />
        )}
      </button>
    </nav>
  );
}
